import { Button } from '@ps/isp-web-component-library';
import { Size } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import {
  TXTWCL_Account_Information,
  TXTWCL_Go_to_Login,
  TXTWCL_Your_session_has_expiredX_Plea_ELL_1
} from './LoggedOut.messages.json';
import styles from './LoggedOut.scss';
import useCloseOnAuth from './hooks/useCloseOnAuth';

const LoggedOut: React.FC = () => {
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { modal } = useDispatch<Dispatch>();
  const isEmbedded = useSelector(select.device.isEmbedded);

  useCloseOnAuth();

  const login = () => {
    if (isEmbedded) {
      modal.close('/sports/logged-out');
      modal.enqueue({ path: '/auth/login' });
    } else {
      modal.replace([{ path: '/auth/login' }]);
    }
  };

  useEffect(
    () =>
      setStyle({
        size: Size.SMALL
      }),
    [setStyle]
  );

  return (
    <section>
      <Header className={styles.header}>
        <Translation {...TXTWCL_Account_Information} />
        <CloseButton />
      </Header>
      <Body className={styles.body}>
        <span className={styles.text}>
          <Translation {...TXTWCL_Your_session_has_expiredX_Plea_ELL_1} />
        </span>
        <Button isFullWidth onClick={login}>
          <Translation {...TXTWCL_Go_to_Login} />
        </Button>
      </Body>
    </section>
  );
};

export default LoggedOut;
